import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.routes, (route, index) => {
      return (_openBlock(), _createBlock(_component_router_link, {
        key: index,
        to: { name: route },
        style: {"margin-bottom":"-1.97px"},
        class: "shrink-0 flex justify-start items-center w-auto m-2 capitalize rounded cursor-pointer p-2 text-gray-400 font-semibold text-sm text-center",
        "exact-active-class": " line-through",
        onClick: $event => {
        $data.selectedGenre = route;
        _ctx.$emit('selected-genre', route);
      }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString($props.titles[index]), 1)
        ]),
        _: 2
      }, 1032, ["to", "onClick"]))
    }), 128))
  ]))
}